import { ReactElement } from 'react';
import { useLocation } from 'react-router';
import { useGetDesignSevenPages } from '@legacy/apis/pagesAPI/designSevenAPI';
import { LoadingSpinner } from '@legacy/components/ui-components/LoadingSpinner';
import { isAPILoadingLegacyPage, LOADING } from './isAPILoadingLegacyPage';

interface AuthRouteProps {
  children: ReactElement;
}

export const LegacyRoute = ({ children }: AuthRouteProps) => {
  const { pathname } = useLocation();
  const { isLoading: isDesignSevenLoading, designSevenPageList } =
    useGetDesignSevenPages();
  const isLoading =
    isAPILoadingLegacyPage({
      isLoading: isDesignSevenLoading,
      pathname,
      designSevenPageList,
    }) === LOADING;

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return children;
};

export default LegacyRoute;
